'use client';

import { useEffect } from 'react';
import { useStore } from 'zustand';
import { useLocalStorage } from 'usehooks-ts';

import { userLocationStore } from '@/store/user-location.store';
import { AutocompletePrediction } from '@/types/google-maps.types';

const STORAGE_KEY = 'recent-location-searches';

export function useRecentLocationSearches() {
  const [stored, setStored] = useLocalStorage<AutocompletePrediction[]>(
    STORAGE_KEY,
    [],
  );

  const recentSearches = useStore(
    userLocationStore,
    (state) => state.recentLocationSearches,
  );

  useEffect(() => {
    if (stored.length) {
      userLocationStore.setState({
        recentLocationSearches: stored,
      });
    }
  }, []);

  useEffect(() => {
    setStored(recentSearches);
  }, [recentSearches]);

  const add = (place: AutocompletePrediction) => {
    userLocationStore.setState((state) => ({
      recentLocationSearches: [
        place,
        ...state.recentLocationSearches.filter(
          (p) => p.placeId !== place.placeId,
        ),
      ].slice(0, 5),
    }));
  };

  const clear = () => {
    userLocationStore.setState({ recentLocationSearches: [] });
  };

  return {
    recentSearches,
    addRecentSearch: add,
    clearRecentSearches: clear,
  };
}
